import { Action } from "redux";
import { ActionCreator } from "typedActions";

export const SET_MOBILE_APP_BANNER_OPEN = "SET_MOBILE_APP_BANNER_OPEN";
export interface ISetMobileAppBannerOpen extends Action {
    open: boolean;
}
export const CreateSetMobileAppBannerOpen = ActionCreator<ISetMobileAppBannerOpen>(SET_MOBILE_APP_BANNER_OPEN);
